'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CoveApi = require('../lib/CoveApi');

var _CoveApi2 = _interopRequireDefault(_CoveApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Class for the Partner Quote API
 */
var PartnerQuote = function (_CoveAPI) {
  (0, _inherits3.default)(PartnerQuote, _CoveAPI);

  /**
   * Creates a new PartnerQuote API Client
   * @param {string} environment
   * @param {{accessToken: string, apiKey: string, refreshInterval: number}} auth
   */
  function PartnerQuote(host, environment, auth) {
    (0, _classCallCheck3.default)(this, PartnerQuote);
    return (0, _possibleConstructorReturn3.default)(this, (PartnerQuote.__proto__ || (0, _getPrototypeOf2.default)(PartnerQuote)).call(this, host, 'partner/quote/motor/comprehensive/v1', environment, auth));
  }

  /**
   * Creates TL customer and quote from partner quote
   * @param {string} host
   * @param {string} quote_id - quote_id generated from Partner Quote
   */


  (0, _createClass3.default)(PartnerQuote, [{
    key: 'createCoveQuote',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(quote_id, accessToken) {
        var data;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.apiClient.fetch('POST', 'createCoveQuote', {
                  quote_id: quote_id,
                  accessToken: accessToken
                });

              case 2:
                data = _context.sent;
                return _context.abrupt('return', data);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createCoveQuote(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return createCoveQuote;
    }()

    /**
     * Creates TL quote from partner estimate
     * @param {string} host
     * @param {string} quote_id - quote_id generated from Partner Quote
     */

  }, {
    key: 'createCoveSharesiesQuote',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(quote_id, accessToken) {
        var data;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.apiClient.fetch('POST', 'createCoveSharesiesQuote', {
                  quote_id: quote_id,
                  accessToken: accessToken
                });

              case 2:
                data = _context2.sent;
                return _context2.abrupt('return', data);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createCoveSharesiesQuote(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return createCoveSharesiesQuote;
    }()
  }]);
  return PartnerQuote;
}(_CoveApi2.default);

exports.default = PartnerQuote;